import React from 'react';
import { Helmet } from 'react-helmet-async';
import Hero from '../components/home/Hero';
import TrustBar from '../components/home/TrustBar';
import FeaturedWork from '../components/home/FeaturedWork';
import ServicesPreview from '../components/home/ServicesPreview';
import ProcessSteps from '../components/home/ProcessSteps';
import WhyUs from '../components/home/WhyUs';
import CtaBanner from '../components/home/CtaBanner';

const Home = () => (
  <>
    <Helmet>
      <title>Nexgeius | Websites, Custom Software & AI Automation Toronto</title>
      <meta name="description" content="Nexgeius is a Toronto development studio building custom websites, business software, and practical AI automation. Website launches start at CA$695." />
      <meta name="robots" content="index, follow" />
      <link rel="canonical" href="https://www.nexgeius.com/" />
      <meta property="og:type" content="website" />
      <meta property="og:title" content="Nexgeius | Websites, Custom Software & AI Automation" />
      <meta property="og:description" content="Custom digital work with a clear scope, visible costs, and support after launch." />
      <meta property="og:url" content="https://www.nexgeius.com/" />
      <meta property="og:site_name" content="Nexgeius" />
      <meta property="og:image" content="https://www.nexgeius.com/projects/fieldstack.jpg" />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:image" content="https://www.nexgeius.com/projects/fieldstack.jpg" />
      <script type="application/ld+json">{JSON.stringify({
        '@context': 'https://schema.org',
        '@type': 'WebSite',
        name: 'Nexgeius',
        url: 'https://www.nexgeius.com/',
      })}</script>
      <script type="application/ld+json">{JSON.stringify({
        '@context': 'https://schema.org',
        '@type': 'ProfessionalService',
        name: 'Nexgeius',
        url: 'https://www.nexgeius.com/',
        description: 'Toronto-based development team building custom websites, business software, and practical AI automation.',
        email: 'nexgeius@gmail.com',
        priceRange: '$$',
        address: { '@type': 'PostalAddress', addressLocality: 'Toronto', addressRegion: 'ON', addressCountry: 'CA' },
        areaServed: [{ '@type': 'City', name: 'Toronto' }, { '@type': 'Country', name: 'Canada' }],
        hasOfferCatalog: {
          '@type': 'OfferCatalog',
          name: 'Nexgeius services',
          itemListElement: [
            { '@type': 'Offer', itemOffered: { '@type': 'Service', name: 'Website Development' } },
            { '@type': 'Offer', itemOffered: { '@type': 'Service', name: 'Custom Software' } },
            { '@type': 'Offer', itemOffered: { '@type': 'Service', name: 'AI Automation' } },
            { '@type': 'Offer', itemOffered: { '@type': 'Service', name: 'Maintenance and Support' } },
          ],
        },
      })}</script>
      <script type="application/ld+json">{JSON.stringify({
        '@context': 'https://schema.org',
        '@type': 'FAQPage',
        mainEntity: [
          {
            '@type': 'Question',
            name: 'What is the most affordable website package?',
            acceptedAnswer: { '@type': 'Answer', text: 'A focused website launch page starts at CA$695 before tax, domain, hosting, and any third-party services. A custom one-page site begins at CA$1,250.' },
          },
          {
            '@type': 'Question',
            name: 'What does Nexgeius build?',
            acceptedAnswer: { '@type': 'Answer', text: 'Nexgeius focuses on custom business websites, custom software such as portals and internal tools, and practical AI automation for repetitive workflows.' },
          },
          {
            '@type': 'Question',
            name: 'Does Nexgeius offer ongoing support?',
            acceptedAnswer: { '@type': 'Answer', text: 'Yes. Optional website care starts at CA$149 per month, while larger software and automation systems use a scoped support retainer.' },
          },
        ],
      })}</script>
    </Helmet>
    <main>
      <Hero />
      <TrustBar />
      <FeaturedWork />
      <ServicesPreview />
      <ProcessSteps />
      <WhyUs />
      <CtaBanner />
    </main>
  </>
);

export default Home;
